import BaseBlockMap from './BaseBlockMap';
import ChequingBlockMap from './ChequingBlockMap';


export default {
    ...BaseBlockMap,
    ...ChequingBlockMap,
};
